import { QuestionStep } from '../QuestionStep';
import { ChoiceGrid } from './_shared';
import {
  NAV_LINK_COUNT_OPTIONS,
  STEPS,
  type QuestionnaireAnswers,
} from '../questions';

interface NavigationStepProps {
  answers: QuestionnaireAnswers;
  onChange: (next: Partial<QuestionnaireAnswers>) => void;
}

export function NavigationStep({ answers, onChange }: NavigationStepProps) {
  const step = STEPS.find((s) => s.id === 'navigation')!;
  return (
    <QuestionStep step={step}>
      <ChoiceGrid
        options={NAV_LINK_COUNT_OPTIONS}
        value={answers.nav_link_count}
        onChange={(v) => onChange({ nav_link_count: v })}
        columns={3}
      />
      <p className="mt-6 max-w-xl font-mono text-[11px] text-graphite leading-relaxed">
        <span className="text-ochre">¶</span>&nbsp;&nbsp;Hick's Law: every additional choice in a top-nav increases decision time. AURA's validator agent (LEX) flags more than seven primary links and suggests grouping under a "More" dropdown.
      </p>
    </QuestionStep>
  );
}
